<form class="coverPathForm" id="ssnForm" [formGroup]="ssnForm">
  <div class="correction-form__container">
    <div class="correction-form__content correction-header label-basic__content">{{ headerText }}</div>
    <div class="form form--name-long">
      <div class="correction-form__content correction-header">
        <div class="correction-form__label form__label">
          <basic-label displayText="Full Name"></basic-label>
        </div>
        <!-- <div class="correction-form__label form__label">
          <basic-label displayText="{{ nameFieldText }}"></basic-label>
        </div> -->
        <div class="form__inline-field-container">
          <div class="form__field">
            <basic-text-input
              [placeholder]="'First Name'"
              formControlName="firstName"
              [formGroupComponent]="true"
              [ngClass]="{ 'entry-field--error': ssnForm.get('firstName').errors && ssnForm.get('firstName').touched }"
            ></basic-text-input>
            <control-messages
              class="error-message error-message--entry-field"
              [control]="ssnForm.get('firstName')"
            ></control-messages>
          </div>
          <div class="form__field">
            <basic-text-input
              [placeholder]="'Middle Name'"
              formControlName="middleName"
              [formGroupComponent]="true"
              [ngClass]="{
                'entry-field--error': ssnForm.get('middleName').errors && ssnForm.get('middleName').touched
              }"
            ></basic-text-input>
            <control-messages
              class="error-message error-message--entry-field"
              [control]="ssnForm.get('middleName')"
            ></control-messages>
          </div>
          <div class="form__field">
            <basic-text-input
              [placeholder]="'Last Name'"
              formControlName="lastName"
              [formGroupComponent]="true"
              [ngClass]="{ 'entry-field--error': ssnForm.get('lastName').errors && ssnForm.get('lastName').touched }"
            ></basic-text-input>
            <control-messages
              class="error-message error-message--entry-field"
              [control]="ssnForm.get('lastName')"
            ></control-messages>
          </div>
        </div>
      </div>
    </div>

    <div class="form form--ssn">
      <div class="correction-form__question">
        <div class="correction-form__label form__label">
          <basic-label displayText="Social Security Number (if available)"></basic-label>
        </div>
        <div class="form__field">
          <basic-text-input
            #ssnValue
            [formGroupComponent]="true"
            [formatterType]="'ssn'"
            [inputType]="'text'"
            [parserType]="'SSN'"
            (focusin)="showSSN()"
            (focusout)="obfuscateSSN()"
            [ngClass]="{ 'entry-field--error': ssnForm.get('ssn').errors && ssnForm.get('ssn').touched }"
          ></basic-text-input>
          <control-messages
            class="error-message error-message--entry-field"
            [control]="ssnForm.get('ssn')"
          ></control-messages>
        </div>
      </div>
    </div>

    <div class="form form--date-long">
      <div class="correction-form__question">
        <div class="correction-form__label form__label">
          <basic-label displayText="Date of Birth"></basic-label>
        </div>
        <div class="form__field">
          <basic-text-input
            formControlName="dob"
            [formGroupComponent]="true"
            [parserType]="'Date'"
            [formatterType]="'date_mmddyyyy'"
            [ngClass]="{ 'entry-field--error': ssnForm.get('dob').errors && ssnForm.get('dob').touched }"
          ></basic-text-input>
          <control-messages
            class="error-message error-message--entry-field"
            [control]="ssnForm.get('dob')"
          ></control-messages>
        </div>
      </div>
    </div>

    <div class="form form--address-long">
      <div class="correction-form__question">
        <div class="correction-form__label form__label">
          <basic-label displayText="Address"></basic-label>
        </div>

        <div class="form--address-long__field--line-1">
          <basic-text-input
            [placeholder]="'Line 1'"
            formControlName="street"
            [formGroupComponent]="true"
            [ngClass]="{ 'entry-field--error': ssnForm.get('street').errors && ssnForm.get('street').touched }"
          ></basic-text-input>
          <control-messages
            class="error-message error-message--entry-field"
            [control]="ssnForm.get('street')"
          ></control-messages>
        </div>

        <div class="form--address-long__field--line-2">
          <basic-text-input
            [placeholder]="'Line 2'"
            formControlName="line1"
            [formGroupComponent]="true"
          ></basic-text-input>
        </div>
        <div class="form__inline-field-container">
          <div class="form__field">
            <basic-text-input
              [placeholder]="'Zip'"
              formControlName="zip"
              [formGroupComponent]="true"
              [ngClass]="{ 'entry-field--error': ssnForm.get('zip').errors && ssnForm.get('zip').touched }"
            ></basic-text-input>
            <control-messages
              class="error-message error-message--entry-field"
              [control]="ssnForm.get('zip')"
            ></control-messages>
          </div>

          <div class="form__field">
            <basic-text-input
              [placeholder]="'City'"
              formControlName="city"
              [formGroupComponent]="true"
              [ngClass]="{ 'entry-field--error': ssnForm.get('city').errors && ssnForm.get('city').touched }"
            ></basic-text-input>
            <control-messages
              class="error-message error-message--entry-field"
              [control]="ssnForm.get('city')"
            ></control-messages>
          </div>

          <div class="form__field">
            <basic-text-input [placeholder]="'State'" formControlName="state" [isState]="true"></basic-text-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
<button
  *ngIf="changesWereMade"
  class="correction-form__button button button--primary button--yellow"
  [ngClass]="{ 'button--disabled': this.ssnForm.valid === false }"
  (click)="validateAndContinue()"
>
  Update
</button>
<button
  *ngIf="!changesWereMade"
  class="correction-form__button button button--primary button--yellow"
  [ngClass]="{ 'button--disabled': this.ssnForm.valid === false }"
  (click)="flipPage()"
>
  Everything Looks Right
</button>
